import { useContext } from "react";
import { CaseAnalysisContext } from "../Contexts";

export const useCaseAnalysis = () => {
  const context = useContext(CaseAnalysisContext);

  if (!context) {
    throw new Error(
      "useCaseAnalysis must be used within a CaseAnalysisProvider"
    );
  }

  return context;
};
